module.exports = __webpack_public_path__ + "static/media/HOW TO USE COVER GENIUS IN EZYMIGRATE SYSTEM.f2e14eb2.png";